export default {"src":"/_next/static/media/capy_money.3f25c545.svg","height":412,"width":356};